export type ProgramSource = {
    vertexShader: WebGLShader;
    fragmentShader: WebGLShader;
};

export const createProgram = (gl: WebGLRenderingContext, source: ProgramSource): WebGLProgram => {

    const program = gl.createProgram();
    // @ts-ignore
    gl.attachShader(program, source.vertexShader);
    // @ts-ignore
    gl.attachShader(program, source.fragmentShader);
    // @ts-ignore
    gl.linkProgram(program);
    // @ts-ignore
    if (gl.getProgramInfoLog(program)) {
        // @ts-ignore
        if (gl.getShaderInfoLog(source.vertexShader)) {
            console.error(gl.getShaderInfoLog(source.vertexShader));
        }
        // @ts-ignore
        if (gl.getShaderInfoLog(source.fragmentShader)) {
            // @ts-ignore
            console.error(gl.getShaderInfoLog(source.fragmentShader));
        }

        // @ts-ignore
        throw new Error(gl.getProgramInfoLog(program as WebGLProgram) ?? "");
    }
    // @ts-ignore
    return program;
};